import { CountryISO, NgxIntlTelInputModule, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';

import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
	selector: 'app-phone-number-control',
	imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule],
	templateUrl: './phone-number-control.component.html',
	styleUrl: './phone-number-control.component.scss',
})
export class PhoneNumberControlComponent<T extends { [K in keyof T]: AbstractControl }> {
	@Input() formGroup!: FormGroup<T>;
	@Input() name!: Extract<keyof T, string | number>;

	CountryISO = CountryISO;
	PhoneNumberFormat = PhoneNumberFormat;
	SearchCountryField = SearchCountryField;

	get control() {
		return this.formGroup.controls[this.name];
	}

	get cssClass() {
		return this.control.invalid && this.control.touched ? 'form-control is-invalid' : 'form-control';
	}
}
